<template>
  <div class="home-lojas">
    <v-container class="pa-0" fluid>
      <v-card class="my-3 px-6">
        <v-card-title>
          <span class="section-title">Lojas</span>
        </v-card-title>
        <v-card-text>
          <span
            >A criação de novas lojas deve ser realizada através do Starlord. Dentro do menu "Clientes", após selecionar o cliente, dentro da aba "Lojas"</span
          >
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
export default {
  mounted() {
    document.title = 'Configurações de Lojas'
  },
}
</script>
